import request from '@/router/axios';

// 回款认领
// export function hkList(query) {
//   return request({
//     url: '/api/returnMoney/page/all',
//     method: 'get',
//     params: query
//   })
// }
// //修改录入回款
// export function editLrhk(query) {
//   return request({
//     url:'/api/returnMoney/update',
//     method: 'post',
//     data: query
//   })
// }
//动态获取合作信息
export function getHz(query) {
  return request({
    url:'/api/frameworkAgreement/cooperation/info',
    method: 'get',
    params: query
  })
}
//获取框架协议列表
export function getXyList(query) {
  return request({
    url:'/api/frameworkAgreement/page/all',
    method: 'get',
    params: query
  })
}
//查看框架框架协议详情
export function getXydetail(query) {
  return request({
    url:'/api/frameworkAgreement/get/detail',
    method: 'get',
    params: query
  })
}
//删除框架协议
export function delXy(query) {
  return request({
    url:'/api/frameworkAgreement/delete',
    method: 'get',
    params: query
  })
}
//查看之前保存的盖章文件
export function sealFile(query){
  return request({
    url:'/api/frameworkAgreement/get/seal/info',
    method: 'get',
    params: query
  })
}
///申请盖章 
export function sqSeal(query) {
  return request({
    url:'/api/frameworkAgreement/apply/seal',
    method: 'post',
    data: query
  })
}
///保存申请盖章文件
export function bcSeal(query) {
  return request({
    url:'/api/frameworkAgreement/save/seal/info',
    method: 'post',
    data: query
  })
}
//查看盖章审批详情 
export function getGzInfo(query){
  return request({
    url:'/api/frameworkAgreement/seal/audit/detail',
    method: 'get',
    params: query
  })
}
//作废
export function ZFAgree(query){
  return request({
    url:'/api/frameworkAgreement/cancel/seal',
    method: 'get',
    params: query
  })
}
//重新申请盖章
export function resetSq(query) {
  return request({
    url:'/api/frameworkAgreement/afresh/seal',
    method: 'post',
    data: query
  })
}
//获取客户列表
export function getKh(query) {
  return request({
    url:'/api/customer/page',
    method: 'get',
    params: query
  })
}
//获取商务合同列表
export function getHt(query) {
  return request({
    url:'/api/frameworkAgreement/contract/page',
    method: 'get',
    params: query
  })
}
//创建框架协议
export function addAgree(query) {
  return request({
    url:'/api/frameworkAgreement/add',
    method: 'post',
    data: query
  })
}
//编辑框架协议
export function editAgree(query) {
  return request({
    url:'/api/frameworkAgreement/update',
    method: 'post',
    data: query
  })
}
//查询关联合同列表
export function getGlList(query) {
  return request({
    url:'/api/frameworkAgreement/frameworkAgreement_contract/page',
    method: 'get',
    params: query
  })
}
//协议盖章列表查询
export function getXygzList(query) {
  return request({
    url:'/api/frameworkAgreement/seal/page',
    method: 'get',
    params: query
  })
}
//盖章btb
export function GZbtn(query) {
  return request({
    url:'/api/frameworkAgreement/seal',
    method: 'get',
    params: query
  })
}
